import React, { Component } from 'react';
import OrderDetailView from '../views/OrderDetailView';
import { base } from '../../base';

class OrderDetailContainer extends Component {
    constructor(props) {
        super(props);
        this.state = {
            order: {}
        };
    }
    componentDidMount() {
        const orderId = this.props.match.params.orderId;
        this.dataRef = base.syncState(`orders/${orderId}`, {
            context: this,
            state: 'order'
        });
    }
    componentWillUnmount() {
        base.removeBinding(this.dataRef);
    }

    render() {
        return <OrderDetailView order={this.state.order} />
    }
}

export default OrderDetailContainer;



// WEBPACK FOOTER //
// ./src/components/containers/OrderDetailContainer.jsx